import { defineMessages } from 'react-intl'

export const backButtonMessages = defineMessages({
  title: {
    id: 'backButton.title',
    description: 'Text on aside menu button that leads to jobs list page',
    defaultMessage: 'Back',
  },
})
